import type { ReactNode } from 'react';

export const symbol_settings_backup_restore: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-120q-143 0-245.5-95.5T121-451q-1-12 7.5-21t21.38-9q12.12 0 20.62 8.5Q179-464 181-451q11 115 96 193t203 78q125.36 0 212.68-87.32Q780-354.64 780-480q0-125.36-87.32-212.68Q605.36-780 480-780q-69 0-129 30.5T246-667h74q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H172q-12.75 0-21.37-8.63Q142-624.25 142-637v-148q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v76q53-62 125.22-96.5Q399.43-840 480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm-.04-285Q449-405 427-427.04q-22-22.05-22-53Q405-511 427.04-533q22.05-22 53-22Q511-555 533-532.96q22 22.05 22 53Q555-449 532.96-427q-22.05 22-53 22Z"
		/>
	</svg>
);
